/* Copyright (c) Trimble Inc. All rights reserved. */

import { useEffect } from 'react';
import { useModusModal } from '@tcp-base/design-system';
import { useSessionExpiryMonitor } from '../../hooks/useSessionExpiryMonitor.hook';
import { SessionExpiryDialogViewerProps } from './SessionExpiryDialog.model';

/**
 * Controller for SessionExpiryDialog.
 *
 * Bridges the useSessionExpiryMonitor hook with the Modus modal open/close API
 * and returns the view-model consumed by SessionExpiryDialogViewer.
 */
export const useSessionExpiryDialogController = (): SessionExpiryDialogViewerProps => {
  const { isDialogOpen, countdown, onStaySignedIn, onLogout } = useSessionExpiryMonitor();
  const { modalRef, openModal, closeModal } = useModusModal();

  // Open/close the native dialog element whenever isDialogOpen changes
  useEffect(() => {
    if (isDialogOpen) {
      openModal();
    } else {
      closeModal();
    }
  }, [isDialogOpen, openModal, closeModal]);

  return {
    modalRef,
    countdown,
    onStaySignedIn,
    onLogout,
  };
};

export default useSessionExpiryDialogController;
